import DescriptionListItem, {
  DescriptionListItemProps,
  QuestionPrefix,
} from './DescriptionListItem';

export type { DescriptionListItemProps };
export { QuestionPrefix };
export default DescriptionListItem;
